import { AlertTriangle, CheckCircle2, Upload } from "lucide-react";

export const RolesImportCard = ({ importing, importResult, onImport }) => (
  <div
    data-testid="roles-import-card"
    className="mt-10 rounded-xl border border-slate-200 bg-white p-6 lg:p-8"
  >
    <div className="flex flex-wrap items-start gap-6 justify-between">
      <div className="max-w-xl">
        <h2 className="font-display text-2xl font-bold text-slate-900">
          Update the roles dataset
        </h2>
        <p className="mt-2 text-sm text-slate-600">
          Upload a CSV in the <b>roles export</b> column shape to replace
          every role, skill mapping and demand entry in one go. The new
          snapshot is persisted, so a server restart won&apos;t lose it.
        </p>
        <p className="mt-2 text-xs text-slate-500">
          Tip: download the current dataset below, edit it in Excel or
          Google Sheets, then upload the edited file back here.
        </p>
      </div>
      <label
        data-testid="roles-import-btn"
        className={`inline-flex items-center gap-2 rounded-md px-5 py-3 text-sm font-semibold cursor-pointer transition-colors ${importing ? "bg-slate-300 text-slate-500 cursor-not-allowed" : "bg-slate-900 text-white hover:bg-slate-800"}`}
      >
        <Upload size={16} className={importing ? "animate-pulse" : ""} />
        {importing ? "Uploading…" : "Upload roles CSV"}
        <input
          data-testid="roles-import-file"
          type="file"
          accept=".csv,text/csv"
          disabled={importing}
          onChange={(e) => {
            const f = e.target.files?.[0];
            e.target.value = "";
            if (f) onImport(f);
          }}
          className="hidden"
        />
      </label>
    </div>

    {importResult && (
      <div
        data-testid="import-result"
        className="mt-6 rounded-lg border border-slate-200 bg-slate-50 p-5"
      >
        <div className="flex items-center gap-2 text-sm font-semibold text-emerald-800">
          <CheckCircle2 size={16} /> Imported{" "}
          <span className="font-mono">{importResult.filename}</span>
        </div>
        <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
          {Object.entries(importResult.imported || {}).map(([k, v]) => (
            <div
              key={k}
              className="rounded-md bg-white border border-slate-200 px-3 py-2"
            >
              <p className="text-[11px] uppercase tracking-wider text-slate-500">
                {k.replace(/_/g, " ")}
              </p>
              <p className="font-display font-bold text-slate-900">{v}</p>
            </div>
          ))}
        </div>
      </div>
    )}

    <div className="mt-5 rounded-md border border-slate-200 bg-slate-50 px-4 py-3 text-xs text-slate-600 flex items-start gap-2">
      <AlertTriangle size={14} className="text-amber-700 shrink-0 mt-0.5" />
      <span>
        The legacy Google Sheets sync has been retired — the 137-role sheet
        was inaccurate. CSV upload is the only supported way to update roles
        now.
      </span>
    </div>
  </div>
);

export default RolesImportCard;
